<template>
    <div class="grid">
        <div class="grid__col-12">
            <div class="mowing-selection__options-container">
                <div
                    v-for="(option, optionIdx) in pricedMowingOptions"
                    :key="option.price.price_id"
                    class="mowing-selection__option"
                >
                    <ls-service-frequency-select-item
                        :selected-price-option="mowingInCart"
                        :price-option="option"
                        :most-popular="determineMostPopularOption({ optionIdx })"
                        @priceOptionSelected="mowingSelected($event)"
                    ></ls-service-frequency-select-item>
                </div>
                <div
                    v-if="showCustomOneTimeMowingOption"
                    class="mowing-selection__option mowing-selection__custom_one-time"
                    test-id="custom-quote"
                >
                    <ls-service-frequency-select-item
                        v-ls-track.click="{
                            target: 'subscription-option--one-time-quote',
                        }"
                        :render-as-button="true"
                        :price-option="oneTimeMowingCustomQuoteOption"
                        @priceOptionSelected="gotoOneTimeMowRequest()"
                    ></ls-service-frequency-select-item>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { mapActions, mapGetters } from 'vuex';
import * as types from '@/store/types';
import lsTrackService from '@/services/ls-track/ls-track.service';
import lsServiceFrequencySelectItem from '@/components/original-mydot/service-frequency-select-item/ServiceFrequencySelectItem.vue';

export default {
    components: {
        lsServiceFrequencySelectItem,
    },
    props: {},
    data() {
        return {
            oneTimeMowingCustomQuoteOption: {
                price: {
                    price_id: null,
                    cycle: 0,
                },
                service: {
                    name: 'Lawn Mowing',
                    service_id: 1,
                },
            },
            nonMowingOption: {
                price: {
                    price_id: null,
                    cycle: 0,
                },
                service: {
                    name: "I Don't Want Mowing",
                    service_id: null,
                },
            },
        };
    },
    computed: {
        ...mapGetters({
            pricedMowingOptions: types.ORDER__GET_PRICED_MOWING_OPTIONS,
            oneTimeMowingOption: types.ORDER__GET_HAS_ONE_TIME_MOWING_OPTION,
            mowingInCart: types.CART__GET_MOWING_IN_CART,
        }),

        showCustomOneTimeMowingOption() {
            return !this.oneTimeMowingOption;
        },
    },
    methods: {
        ...mapActions({
            addServiceToCart: types.CART__ADD_SERVICE_TO_CART,
        }),

        determineMostPopularOption({ optionIdx }) {
            return optionIdx === 0 && _.size(this.pricedMowingOptions) > 1;
        },

        gotoOneTimeMowRequest() {
            this.$router.push({ name: 'oneTimeMowingForm' });
        },

        gotoNonMowingForm() {
            this.$router.push({ name: 'nonMowingForm' });
        },

        mowingSelected(mowPriceOption) {
            lsTrackService.track({
                type: 'change',
                target: 'subscription-option',
                data: {
                    price_id: mowPriceOption.price.price_id,
                },
            });

            this.addServiceToCart(mowPriceOption);
        },
    },
};
</script>

<style lang="scss">
.mowing-selection__options-container {
    display: flex;
    justify-content: space-between;
    margin-bottom: rem(-4);

    @include max-screen(breakpoint(xs, max)) {
        flex-wrap: wrap;
    }

    > * {
        flex: 1 0 auto;

        @include max-screen(breakpoint(xs, max)) {
            flex-basis: auto; // preserve auto for wrapping functionality on xs screens
            width: 100%;
            max-width: 100%;
        }

        @include min-screen(breakpoint(sm)) {
            flex-basis: 0%; // % required for IE, ensures all elements are same width
        }
    }
}
</style>
